import { Stack, styled as muiStyled } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const ActionHeaderContainer = muiStyled(Stack, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: 'default' | 'compact' }>(({ variant }) => ({
  width: '100%',
  padding: variant === 'default' ? '1.2rem' : '1.2rem 1.6rem',
  background: abyssColors.primary[variant === 'default' ? 50 : 100],
  borderRadius: '0.4rem',
  alignItems: 'center',
  justifyContent: variant === 'default' ? 'space-between' : 'flex-end',
  flexDirection: 'row',
  height: 'fit-content',
  marginTop: '1.6rem',
  marginBottom: '1.2rem',
}));
